module.exports = __webpack_public_path__ + "img/workshop.b62e18fa.webp";